// extracted by mini-css-extract-plugin
export default {"container":"Callback_container__Rk+hg","CloseCircle":"Callback_CloseCircle__2kGQf"};